import { generateId } from './utils/CommonUtils';

export const results = {
  InitUserRegistration: {
    ts: '1573827246.672',
    ns: 'operator/api/registration',
    method: 'InitUserRegistration',
    error: {
      recaptcha_score: 0.4,
      msg: 'recaptcha_score is too low',
    },
    id: generateId('InitUserRegistration'),
  },

  /*
  InitUserRegistration: {
    ts: "1573827246.672",
    ns: 'operator/api/registration',
    method: 'InitUserRegistration',
    result: {
      recaptcha_score: 0.9,
    },
    id: generateId('InitUserRegistration'),
  },
  */

  CreateUserRegistration: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'CreateUserRegistration',
    result: {
      jwt: '15158281FFD',
    },
    id: generateId('CreateUserRegistration'),
  },

  /*
  "CreateUserRegistration" : {
    error: {
      "code": -32602,
      "message": "Invalid params",
      "data": {
        "type": "BadRequest",
        "field_violations": [
          {
            "field": "password",
            "description": "Missing or incorrect value"
          }
        ],
      }
    }
  },
  */

  /*
  "CreateUserRegistration" : {
    error: {
      "code": -32602,
      "message": "Invalid params",
      "data": {
        "type": "BadRequest",
        "field_violations": [
          {
            "field": "email",
            "description": "Cet email est déjà associé à un compte. Connecte-toi par ici."
          }
        ],
      }
    }
  },
  */

  SendUserRegistrationSMSCode: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    result: {},
    id: generateId('SendUserRegistrationSMSCode'),
  },

  /*
  "SendUserRegistrationSMSCode" : {
    "error": {
      "code": -32401,
      "message": "Unauthorized",
      "data": []
    }
  },
  */

  ValidateUserRegistrationSMSCode: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'ValidateUserRegistrationSMSCode',
    result: {},
    id: generateId('ValidateUserRegistrationSMSCode'),
  },

  /*
  "ValidateUserRegistrationSMSCode" : {
    error: {
      "code": -32602,
      "message": "Invalid params",
      "data": {
        "type": "BadRequest",
        "field_violations": [
          {
            "field": "otp",
            "description": "Ton code de vérification n'est pas valable."
          }
        ],
      }
    }
  },
  */

  UpdateUserRegistration: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    result: {},
    id: generateId('UpdateUserRegistration'),
  },

  /*
  UpdateUserRegistration: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    error: {
      code: -32602,
      message: "Invalid params",
      data:
      {
        type: "BadRequest",
        field_violations: [
          {
            field: "nickname",
            description: "Missing or incorrect value"
          } ]
      } },
    id: generateId('UpdateUserRegistration'),
  },
  */

  SuggestNickname: {
    result: {
      suggested: [
        { nickname: 'GastonLaTerreur1' },
        { nickname: 'GagaLeChatteu8' },
        { nickname: 'GagaDeToi3' },
        { nickname: 'GasLaMenace1' },
      ],
    },
    id: generateId('SuggestNickname'),
  },

  /*
  SuggestNickname : {
    "error": {
      "code": -32401,
      "message": "Impossible de récupérer la liste des pseudos.",
      "data": []
    }
  },
  */

  /*
  IsAvailableNickname: {
    ts: 1573827246.672,
    ns: "operator/api/registration",
    method: "IsAvailableNickname",
    error: {
      data: {
        type: "BadRequest",
        field_violations: [
          {
            field: "nickname",
            description: "Nickname is not available"
          }
        ],
      }
    },
    id: generateId('IsAvailableNickname'),
  },
  */

  IsAvailableNickname: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'IsAvailableNickname',
    result: {},
    id: generateId('IsAvailableNickname'),
  },

  UploadUserRegistrationKYC: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'UploadUserRegistrationKYC',
    result: {
      type: 'UserRegistrationKYC',
      data: {
        kyc_id: 'uniq kyc id',
      },
    },
    id: generateId('UploadUserRegistrationKYC'),
  },

  // UploadUserRegistrationKYC: {
  //   error: {
  //     code: -32401,
  //     message: 'Error',
  //   },
  // },

  ScanUserRegistrationKYC: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'UploadUserRegistrationKYC',
    result: {
      type: 'ScannedKYC',
      data: {
        kyc_id: 'uniq kyc id',
        kyc_type: 'identity',
        fields: [
          {
            name: 'first_name',
            type: 'string',
            value: 'Prénom scanné',
            format: '{fieldFormat}',
            confidence: 0.9,
          },
          {
            name: 'last_name',
            type: 'string',
            value: 'Nom scanné',
            format: '{fieldFormat}',
            confidence: 0.9,
          },
        ],
      },
    },
    id: generateId('ScanUserRegistrationKYC'),
  },

  GetUserRegistration: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'GetUserRegistration',
    id: 'GetUserRegistration',
    result: {
      user_id: 'notUsedByFront',
      email: 'adrien@winamax.fr',
      first_name: 'Alex',
      last_name: 'Terrieur',
      second_last_name: 'notUsedByFront',
      pin_code: 'notUsedByFront',
      tax_code: 'notUsedByFront',
      nationality: 'FR',
      gender: 'M',
      birth_date: '1992-08-20',
      birth_city: 'Moscou',
      birth_department: '75',
      birth_country: 'FR',
      address1: '94 avenue Gambetta',
      address2: null,
      zip_code: '75020',
      city: 'Paris',
      state: 'notUsedByFront',
      country: 'FR',
      home_phone: '',
      international_phone_number: '+33699631611',
      swift: null,
      iban: null,
      rib_bank_code: null,
      rib_branch_code: null,
      rib_account: null,
      rib_key: null,
      nickname: 'GagaLaTerreur',
      language: 'FR',
      license: 'FR',
      accept_newsletter: 'notUsedByFront',
      accept_mailings: 'notUsedByFront',
      accept_sms: 'notUsedByFront',
      proof_of_identity_uploaded: true,
      proof_of_address_uploaded: true,
      max_deposit_per_week: '1500',
      first_deposit: true,
      withdrawal_auto_above: '500',
      phone_verified: false,
      address_verified: true,
    },
  },

  ScanCreditCard: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'ScanCreditCard',
    result: {
      data: {
        cardNumber: '4234603011240000',
        owner: 'MICROBLINK SAMPLE',
        validThru: {
          day: '0',
          month: '1',
          year: '2022',
          originalString: '01/22',
        },
        type: 'BLINK_CARD_FRONT',
      },
    },
    id: generateId('ScanCreditCard'),
  },

  InitDepositSession: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'InitDepositSession',
    result: {
      success: true,
    },
    id: generateId('InitDepositSession'),
  },

  /* *** STARTDEPOSIT - NO EXTERNAL STEP *** */
  StartDeposit: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'StartDeposit',
    result: {
      deposit_id: 'deposit_id',
    },
    id: generateId('StartDeposit'),
  },

  /* *** STARTDEPOSIT - REDIRECT *** */
  // StartDeposit: {
  //   ts: 1573827246.672,
  //   ns: 'operator/api/registration',
  //   method: 'StartDeposit',
  //   result: {
  //     external_step: {
  //       action: 'redirect',
  //       content: 'http://localhost:3000/check-deposit/123456',
  //     },
  //     deposit_id: 'deposit_id',
  //   },
  //   id: generateId('StartDeposit'),
  // },

  /* *** STARTDEPOSIT - IFRAME *** */
  // StartDeposit: {
  //   ts: 1573827246.672,
  //   ns: 'operator/api/registration',
  //   method: 'StartDeposit',
  //   result: {
  //     external_step: {
  //       action: 'iframe',
  //       content: 'http://localhost:3000/step2',
  //     },
  //     deposit_id: 'deposit_id',
  //   },
  //   id: generateId('StartDeposit'),
  // },

  /* *** STARTDEPOSIT - HTML *** */
  // StartDeposit: {
  //   ts: 1573827246.672,
  //   ns: 'operator/api/registration',
  //   method: 'StartDeposit',
  //   result: {
  //     external_step: {
  //       action: 'html',
  //       content:
  //         '<form action="http://localhost:3000/step2"><input type="text" value="test" /><input type="submit" value="" /></form>',
  //     },
  //     deposit_id: 'deposit_id',
  //   },
  //   id: generateId('StartDeposit'),
  // },

  /* *** CHECKDEPOSIT - SUCCESS *** */
  CheckDeposit: {
    ts: 1573827246.672,
    ns: 'operator/api/deposit',
    method: 'CheckDeposit',
    result: {
      deposit_id: 'deposit_id',
      status: 'success',
    },
    id: generateId('CheckDeposit'),
  },

  /* *** CHECKDEPOSIT - FAILED *** */
  // CheckDeposit: {
  //   ts: 1573827246.672,
  //   ns: 'operator/api/deposit',
  //   method: 'CheckDeposit',
  //   result: {
  //     deposit_id: 'deposit_id',
  //     status: 'failed',
  //     error: {
  //       code: 1,
  //       message: 'Ton paiement a échoué. Retente ta chance.',
  //     },
  //   },
  //   id: generateId('CheckDeposit'),
  // },

  /* *** CHECKDEPOSIT - PROCESSING *** */
  // CheckDeposit: {
  //   ts: 1573827246.672,
  //   ns: 'operator/api/deposit',
  //   method: 'CheckDeposit',
  //   result: {
  //     deposit_id: 'deposit_id',
  //     status: 'processing',
  //   },
  //   id: generateId('CheckDeposit'),
  // },

  ListAvailableDepositMethods: {
    ts: 1573827246.672,
    ns: 'operator/api/deposit',
    method: 'ListAvailableDepositMethods',
    result: {
      methods: [
        {
          deposit_method: 'credit_card',
          min_amount: 15,
          image: '../../../assets/images/depot/CB.svg',
          fields: [],
        },
        // {
        //   deposit_method: 'oneclick',
        //   min_amount: 15,
        //   image: '',
        //   fields: [
        //     {
        //       name: 'card_alias',
        //       fields: [
        //         {
        //           label: '400000######0001 10/22',
        //           value: 'A1-xxxxxxx-xxxx-xxxxx-xxxxx-xxxxxxxxxxx',
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          deposit_method: 'paysafeCard',
          min_amount: 10,
          image: '../../../assets/images/depot/PAYSAFE.svg',
          fields: [],
        },
        {
          deposit_method: 'ticket_premium',
          min_amount: 0,
          image: '../../../assets/images/depot/TICKETPREMIUM.svg',
          fields: [],
        },
        {
          deposit_method: 'neteller',
          min_amount: 30,
          image: '../../../assets/images/depot/NETELLER.svg',
          fields: [],
        },
        {
          deposit_method: 'moneybookers',
          min_amount: 20,
          image: '../../../assets/images/depot/SKRILL.svg',
          fields: [],
        },
        {
          deposit_method: 'paypal',
          min_amount: 20,
          image: '../../../assets/images/depot/PAYPAL.svg',
          fields: [],
        },
        {
          deposit_method: 'paylib',
          min_amount: 0,
          image: '../../../assets/images/depot/PAYLIB.svg',
          fields: [],
        },
        {
          deposit_method: 'buralist',
          min_amount: 0,
          image: '../../../assets/images/depot/WINAMAX.svg',
          fields: [],
        },
        {
          deposit_method: 'wire_transfer',
          min_amount: 0,
          image: '../../../assets/images/depot/VIREMENTBANCAIRE.svg',
          fields: [],
        },
        {
          deposit_method: 'wire_transfer',
          min_amount: 0,
          image: '../../../assets/images/depot/VIREMENTBANCAIRE.svg',
          fields: [],
        },
      ],
    },
  },

  ValidateUserRegistrationDomiciliationCode: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'ValidateUserRegistrationDomiciliationCode',
    result: {},
    id: generateId('ValidateUserRegistrationDomiciliationCode'),
  },

  /*
  ValidateUserRegistrationDomiciliationCode : {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    error: {
      "code": -32602,
      "message": "Invalid params",
      "data": {
        "type": "BadRequest",
        "field_violations": [
          {
            "field": "domiciliation_code",
            "description": "Le code d'activation n'est pas valable"
          }
        ],
      }
    },
    id: generateId('ValidateUserRegistrationDomiciliationCode'),
  },
  */

  SendUserRegistrationValidationCode: {
    ts: 1573827246.672,
    ns: 'operator/api/registration',
    method: 'SendUserRegistrationValidationCode',
    result: {},
    id: generateId('SendUserRegistrationValidationCode'),
  },
};
